<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  @if (destruction) {
    <app-page-detail-hero [auditStamp]="destruction"
      icon="pi pi-trash"
      [eyebrow]="destruction.destructionNumber || ('Destruction #' + destruction.id)"
      [title]="itemName(destruction.itemId)"
      [subtitle]="(destruction.sourceType || '-') + ' | ' + supplierName(destruction)">
      <div tags>
        <p-tag [value]="destruction.status" [severity]="statusSeverity(destruction.status)"></p-tag>
        <p-tag [value]="destruction.sourceType" severity="secondary"></p-tag>
      </div>
      <div actions>
        <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/warehousing/destruction"></p-button>
        <p-button label="Create" icon="pi pi-plus" severity="danger" routerLink="/warehousing/destruction/add"></p-button>
        @if (canCancel()) {
          <p-button label="Cancel Draft" icon="pi pi-times" severity="secondary" [outlined]="true" [loading]="isSubmitting" (click)="cancelDestruction()"></p-button>
        }
        @if (canConfirm()) {
          <p-button label="Confirm Destruction" icon="pi pi-check" severity="danger" [loading]="isSubmitting" (click)="confirmDestruction()"></p-button>
        }
      </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <div class="warehousing-detail-grid">
      <app-page-form-section icon="pi pi-box" title="Destruction Header" subtitle="Stock unit, item, supplier, source, and destruction reason.">
        <div class="warehousing-detail-list">
          <div><span>Destruction Number</span><strong>{{ destruction.destructionNumber || '-' }}</strong></div>
          <div><span>Stock Unit</span><strong>{{ destruction.stockUnitId }}</strong></div>
          <div><span>Item</span><strong>{{ itemName(destruction.itemId) }}</strong></div>
          <div><span>Source</span><strong>{{ destruction.sourceType }}</strong></div>
          <div><span>Supplier</span><strong>{{ supplierName(destruction) }}</strong></div>
          <div><span>Reason</span><strong>{{ destruction.reason || '-' }}</strong></div>
          <div><span>Requested Date</span><strong>{{ destruction.requestedDate || '-' }}</strong></div>
          <div><span>Confirmed Date</span><strong>{{ destruction.confirmedDate || '-' }}</strong></div>
        </div>
      </app-page-form-section>

      <div class="warehousing-detail-stack">
        <app-page-form-section icon="pi pi-money-bill" title="Quantity and Cost" subtitle="Destroyed quantity and captured cost values.">
          <div class="warehousing-detail-list">
            <div><span>Quantity Destroyed</span><strong>{{ destruction.quantityDestroyed || 0 | number:'1.0-4' }}</strong></div>
            <div><span>Estimated Cost</span><strong>{{ destruction.estimatedCost || 0 | number:'1.2-2' }}</strong></div>
            <div><span>Actual Cost</span><strong>{{ destruction.actualCost || 0 | number:'1.2-2' }}</strong></div>
          </div>
        </app-page-form-section>

        <app-page-form-section icon="pi pi-align-left" title="Notes and Evidence" subtitle="Draft notes and uploaded destruction evidence.">
          <div class="flex flex-column gap-3">
            <div class="surface-ground border-round p-3 line-height-3" [innerHTML]="destruction.notes || '<p>-</p>'"></div>

            @if (evidenceUrls(destruction).length) {
              <div class="grid">
                @for (url of evidenceUrls(destruction); track url) {
                  <div class="col-12 md:col-4">
                    <div class="border-1 surface-border border-round p-3 h-full flex flex-column gap-2">
                    @if (isImageUrl(url)) {
                      <p-image [src]="url" [alt]="evidenceFileName(url)" [preview]="true" width="180"></p-image>
                    } @else {
                      <a [href]="url" target="_blank" rel="noopener noreferrer">{{ evidenceFileName(url) }}</a>
                    }
                    </div>
                  </div>
                }
              </div>
            } @else {
              <span class="cell-meta">No evidence uploaded.</span>
            }
          </div>
        </app-page-form-section>
      </div>
    </div>
  } @else if (!isLoading) {
    <div class="warehousing-empty-detail">
      <i class="pi pi-search"></i>
      <strong>Destruction record not found</strong>
      <span>The selected destruction record could not be loaded.</span>
    </div>
  }
</app-page-shell>
